import { ArrowRight } from "lucide-react";
import { track } from "@/lib/track";

// Compact reusable conversion strip — lightweight, not a full section.
export const CTAStrip = ({
  label = "Ready to talk about your project?",
  cta = "Start Your Project",
  onCta,
}) => (
  <div className="border-t border-carbon-700 bg-carbon-900" data-testid="cta-strip">
    <div className="container-edge flex flex-col items-start justify-between gap-5 py-8 sm:flex-row sm:items-center lg:py-10">
      <p className="font-display text-2xl font-extrabold uppercase tracking-tight text-white sm:text-3xl">
        {label}
      </p>
      <button
        type="button"
        onClick={() => {
          track("cta_start_project", { placement: "cta_strip" });
          onCta?.();
        }}
        className="btn-signal group shrink-0"
        data-testid="cta-strip-btn"
      >
        {cta}
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </div>
  </div>
);
